import React, { createContext, useContext, useState, useEffect } from 'react';

const ScriptLoaderContext = createContext();

export const useScriptLoader = () => {
    const context = useContext(ScriptLoaderContext);
    if (!context) {
        throw new Error('useScriptLoader must be used within ScriptLoaderProvider');
    }
    return context;
};

export const ScriptLoaderProvider = ({ children }) => {
    const [scriptsReady, setScriptsReady] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState({
        pyodide: false,
        monaco: false
    });

    useEffect(() => {
        const checkScripts = () => {
            const pyodideReady = !!window.pyodide;
            const monacoReady = !!window.monaco;
            
            setLoadingStatus({
                pyodide: pyodideReady,
                monaco: monacoReady
            });

            // 필수 스크립트가 모두 로드되었을 때만 true
            if (pyodideReady) {
                setScriptsReady(true);
            }
        };

        // 초기 체크
        checkScripts();

        // Pyodide 로드 이벤트 리스너
        const handlePyodideReady = () => {
            checkScripts();
        };

        window.addEventListener('pyodideReady', handlePyodideReady);

        // 주기적으로 체크 (폴백)
        const interval = setInterval(checkScripts, 500);

        // 10초 후 타임아웃
        const timeout = setTimeout(() => {
            clearInterval(interval);
            // 최소한 기본 기능은 사용할 수 있도록
            setScriptsReady(true);
        }, 10000);

        return () => {
            window.removeEventListener('pyodideReady', handlePyodideReady);
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, []);

    const value = {
        scriptsReady,
        loadingStatus
    };

    // 스크립트가 로드되기 전에는 로딩 화면 표시
    if (!scriptsReady) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                backgroundColor: 'var(--bg-color, #FAF8FF)'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        display: 'inline-block',
                        width: '50px',
                        height: '50px',
                        border: '4px solid #E8DFFC',
                        borderTopColor: '#C8B6F6',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                    }} />
                    <p style={{
                        marginTop: '20px',
                        color: '#666666',
                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
                    }}>
                        학습 환경을 준비하고 있어요...
                    </p>
                    <style>
                        {`
                            @keyframes spin {
                                to { transform: rotate(360deg); }
                            }
                        `}
                    </style>
                </div>
            </div>
        );
    }

    return (
        <ScriptLoaderContext.Provider value={value}>
            {children}
        </ScriptLoaderContext.Provider>
    );
};